import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import './PatientLayout.css';
import PHeader from '../../Header/PHeader';
import PatientMenu from '../../patient/patientmenu/PatientMenu';
import PatientDashboard from '../../patient/PatientDashboard';
import { PatientCasesList } from '../../patient/PatientCasesList';
import { NewCase } from '../../patient/NewCase';
import { PatientFamily } from '../../patient/PatientFamily';
import { PatientReports } from '../../patient/PatientReports';
import { PatientApplications } from '../../patient/PatientApplications';
import { PatientNewApplications } from '../../patient/PatientNewApplications';
import { ViewPatientReports } from '../../patient/ViewPatientReports';
import { ViewPatApplication } from '../../patient/ViewPatApplication';
import { ViewPatientCases } from '../../patient/ViewPatientCases';
import { PatientActivities } from '../../patient/PatientActivities';
import { PatientProfile } from '../../patient/PatientProfile';
import { PatientUploads } from '../../patient/PatientUploads';
import { PatientNewCaseDetails } from '../../patient/PatientNewCaseDetails';
import { AddNormalCase } from '../../patient/AddNormalCase';
import { PayNormalCase } from '../../patient/PayNormalCase';
import { DoctorInfo } from '../../patient/DoctorInfo';
import { PatientFeedback } from '../../patient/PatientFeedback';
import { PatientAppointments } from '../../patient/PatientAppointments';
import { Reset } from '../../reset/Reset';
import { InvoicePrint } from '../../doctor/InvoicePrint';





interface PatientLayout {

  children?: ReactNode;
  // Define children as a ReactNode
}
const PatientLayout: React.FC<PatientLayout> = ({ children }) => {


  return (
    <div className="elitecap-layout-container">
      <PHeader />
      <div >
        <PatientMenu />
        <Routes>
          <Route path="/patientresetpassword" element={<Reset />} />
          <Route path="/patientdashboard" element={<PatientDashboard />} />
          <Route path="/patientcases" element={<PatientCasesList />} />
          <Route path="/patientappointments" element={<PatientAppointments />} />
          <Route path="/createnewcase" element={<NewCase />} />
          <Route path="/patientfamily" element={<PatientFamily />} />
          <Route path="/patreports" element={<PatientReports />} />
          <Route path="/patientinvoice/:id" element={<InvoicePrint />} />

          <Route path="/patientapplications" element={<PatientApplications />} />
          <Route path="/newapplicationpatient" element={<PatientNewApplications />} />
          <Route path="/viewpatreports/:id" element={<ViewPatientReports />} />
          <Route path="/viewpatapplications/:id" element={<ViewPatApplication />} />
          <Route path="/viewpatientcases/:id" element={<ViewPatientCases />} />
          <Route path="/patientactivities" element={<PatientActivities />} />
          <Route path="/patientprofile" element={<PatientProfile />} />
          <Route path="/patientuploads" element={<PatientUploads />} />
          <Route path="/urgentcasecreation" element={<PatientNewCaseDetails />} />
          <Route path="/addnormalcase" element={<AddNormalCase />} />
          <Route path="/paypal" element={<PayNormalCase />} />
          <Route path="/doctorsinformation/:id" element={<DoctorInfo />} />
          <Route path="/patientfeedback/:id" element={<PatientFeedback />} />

        </Routes>
      </div>
      {children}
      {/* <Footer /> */}
    </div>
  );
};

export default PatientLayout;
